import React, { Component } from 'react';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { Api } from './interface';
import FieldList from './fieldList';
import { validateField } from './validator';

import { toast } from 'react-toastify';
// import { COLUMNS } from "./constants";
import { datePickerToShortDate } from './date';
import { Hint } from './constants.js';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Tab from '@mui/material/Tab';
import EquipmentMaintenanceFields from './equipmentMaintenanceFields';
import CapitalAssetSelector from './capitalAssetSelector';
import { fetchIsoData, fetchIsoFields } from './isoUtil.js';
import {
  CAPITAL_ASSET_FIELDS,
  CTAG_FORMAT_MESSAGE,
  CTAG_PATTERN,
} from './constants';
import { getFieldValue } from './common'; // Import the utility function

class EntityEdit extends Component {
  constructor(props) {
    super(props);
    this.tableCellHover = [
      {
        '&:hover': {
          backgroundColor: '#BDBDBD',
        },
      },
    ];

    this.textInput = React.createRef();
    this.commentInput = React.createRef();
    this.historyRef = React.createRef();
    this.bottomRef = React.createRef();

    this.state = {
      entities: [],
      parentEntityList: [],
      filteredItems: [],
      entityTypes: [],
      template: [],
      filteredTemplate: [],
      statuses: [],
      metaOptions: [],
      fieldArray: [],
      isOpen: false,
      cloning: false,
      renaming: false,
      deleting: false,
      statusEdit: -1,
      commenting: false,
      showHistory: true,
      comment: '',
      currentGroupChildren: [],
      currentHistory: [],
      filteredHistory: [],
      currentFilterText: '',
      filterTerm: '',
      filteredRows: [],
      items: props.item,
      templatesDict: {},
      refresh: false,
      currentEntityName: props.items[0].EntityName || '',
      tabValue: '1',
      ISOFields: null,
      // capital asset state for edit
      capitalAsset: {
        isCapitalAsset: false,
        capitalFields: [],
        ioNumbers: [],
        poNumbers: [],
      },
      existingCapitalAsset: {
        isCapitalAsset: false,
        capitalFields: [],
      },
      capitalAssetReadOnly: false,
      readOnlyPOIO: false,
      readOnlyCtag: false,
      maintenanceData: null,
      capitalError: false,
    };
  }

  handleTabChange = (event, newValue) => {
    this.setState({ tabValue: newValue });
  };

  handleEquipmentMaintenanceFieldsChange = (data, isoField) => {
    let maintenanceData = this.state.maintenanceData;
    let updateISOFieldData = [];
    this.props.items?.forEach((item) => {
      let entityMetaValue =
        Object.values(data[item.Entity_DBID]).find(
          (v) => v.EntityMetaType_DBID === isoField.EntityMetaType_DBID
        )?.EntityMetaValue || '';
      updateISOFieldData.push({
        Entity_DBID: item.Entity_DBID,
        EntityMetaType_DBID: isoField.EntityMetaType_DBID,
        EntityMetaValue: entityMetaValue,
      });
    });
    let json = {
      selectedEntities: this.props.items,
      updateISOFieldData: updateISOFieldData,
    };
    Api({
      sp: 'updateISOMaintenanceFieldByEntities',
      json: json,
    }).then((response) => {
      if (response[0].Entity_DBID) {
        let toastMsg = isoField.Label + ' updated ';
        toastMsg =
          this.props.items?.length === 1
            ? toastMsg + ' for ' + this.props.items[0].EntityName
            : toastMsg + ' for ' + this.props.items?.length + ' equipment';
        toast.success(toastMsg);
      }
      this.setState({ maintenanceData: maintenanceData, refresh: true });
    });
  };

  // handler for capital asset changes from CapitalAssetSelector
  handleCapitalAssetChange = (capitalAssetData) => {
    this.setState({
      capitalAsset: {
        isCapitalAsset: capitalAssetData.isCapitalAsset,
        capitalFields: capitalAssetData.capitalFields || [],
        ioNumbers: capitalAssetData.ioNumbers || [],
        poNumbers: capitalAssetData.poNumbers || [],
      },
    });
  };
  async componentDidMount() {
    Api({
      sp: 'getUsers',
      json: {},
    }).then((response) => {
      this.setState({ users: response });
    });
    this.getData();
  }

  updateTemplate(totalItems, allFields, groups) {
    let templateTemp = [];

    let commonValues = [];
    let commonValue = { EntityMetaValue: null };

    // get Lot ID and Quanity for Components
    let lotObj = allFields.find((f) => f.EntityMetaType === 'Lot ID');
    if (lotObj) {
      templateTemp.push(lotObj);
    }

    let qtyObj = allFields.find((f) => f.EntityMetaType === 'Quantity');
    if (qtyObj) {
      templateTemp.push(qtyObj);
    }

    let srObj = allFields.find((f) => f.EntityMetaType === 'Serial Number');
    if (srObj) {
      templateTemp.push(srObj);
    }
    groups.forEach((group) => {
      let fieldInTemplate = templateTemp.filter(
        (x) => x.EntityMetaType_DBID === group.EntityMetaType_DBID
      );

      if (!fieldInTemplate.length) {
        if (!group.AllowMultiple) {
          commonValues = allFields.filter(
            (x) => x.EntityMetaType_DBID === group.EntityMetaType_DBID
          );
          commonValue = commonValues[0];

          if (group.Count !== totalItems) {
            commonValue.EntityMetaValue = null;
          }
          templateTemp.push(commonValue);
        }

        if (group.AllowMultiple) {
          let filteredGroups = groups.filter(
            (x) =>
              x.EntityMetaType_DBID === group.EntityMetaType_DBID &&
              x.Count === totalItems
          );
          if (!filteredGroups.length) {
            commonValues = allFields.filter(
              (x) => x.EntityMetaType_DBID === group.EntityMetaType_DBID
            );
            let commonValue = commonValues[0];
            commonValue.EntityMetaValue = null;
            templateTemp.push(commonValue);
          } else {
            filteredGroups.forEach((x) => {
              commonValues = allFields.filter(
                (r) =>
                  r.EntityMetaType_DBID === x.EntityMetaType_DBID &&
                  r.EntityMetaValue === x.EntityMetaValue
              );
              let commonValue = commonValues[0];
              templateTemp.push(commonValue);
            });
          }
        }
      }
    });

    return templateTemp;
  }

  async getData() {
    Api({
      sp: 'getTemplatesByEntities',
      json: {
        ids: this.props.items.map((a) => a.Entity_DBID),
        level: this.props.level,
      },
    }).then((response) => {
      //remove capital asset fields from template for Equipment level only
      if (this.props.level === '') {
        response = response.filter(
          (r) =>
            ![
              CAPITAL_ASSET_FIELDS.C_TAG,
              CAPITAL_ASSET_FIELDS.IO_NUMBER,
              CAPITAL_ASSET_FIELDS.PO_NUMBER,
            ].includes(r.EntityMetaType)
        );
      }

      let allTemplateFields = response;
      allTemplateFields.forEach((x) => {
        x.initialValue = x.EntityMetaValue;
      });
      this.setState({ allTemplateFields: response });
      let template = response;
      let totalItems = this.props.items.length;

      // get all the grouped and nested data for the selected entities
      Api({
        sp: 'getNestedDataForEntities',
        json: {
          selectedList: this.props.items,
          totalEntities: this.props.items.length,
        },
      }).then((g) => {
        //remove capital asset fields from template for Equipment level
        if (this.props.level === '') {
          g = g.filter(
            (r) =>
              ![
                CAPITAL_ASSET_FIELDS.C_TAG,
                CAPITAL_ASSET_FIELDS.IO_NUMBER,
                CAPITAL_ASSET_FIELDS.PO_NUMBER,
              ].includes(r.EntityMetaType)
          );
        }

        const groups = this.makeTree(
          g.filter(
            (x) =>
              !(
                x.Count === 1 &&
                !x.EntityMetaValue &&
                x.ParentEntityMetaType_DBID
              )
          ),
          (node) => node.ParentEntityMetaType_DBID,
          (node, next) => ({
            ...node,
            children: next(node.EntityMetaType_DBID),
          })
        );
        template = this.updateTemplate(totalItems, allTemplateFields, groups);

        template.forEach((t) => {
          t.children = t.children || [];
          groups.forEach((g) => {
            if (
              t.EntityMetaType_DBID === g.EntityMetaType_DBID &&
              t.EntityMetaValue === g.EntityMetaValue
            ) {
              t.children = g.children;
              if (g.Count === this.props.items.length) {
                t.EntityMetaValue = g.EntityMetaValue;
              }
            }
          });
        });

        Api({
          sp: 'getMetaOptionsByEntities',
          json: {
            ids: this.props.items.map((a) => a.Entity_DBID),
          },
        }).then((response) => {
          let optionsDict = {};

          response.forEach((option) => {
            if (!(option.EntityMetaOption in optionsDict)) {
              optionsDict[option.EntityMetaOption] = 1;
            } else {
              optionsDict[option.EntityMetaOption] += 1;
            }
            option['count'] = optionsDict[option.EntityMetaOption];
          });

          template.forEach((x) => {
            if (!x.options) {
              x.options = [];
            }
            if (x.AllowMultiple) {
              x['values'] = [];
            }

            response.forEach((y) => {
              if (
                x.EntityMetaType_DBID === y.EntityMetaType_DBID &&
                // Avoid adding duplicate options
                !x.options.some(
                  (o) => o.EntityMetaOption === y.EntityMetaOption
                )
              ) {
                x.options.push(y);
              }
            });
          });

          this.setState({
            template: template,
            filteredTemplate: template.filter(
              (f) =>
                f.EntityMetaType.toLowerCase().includes(
                  this.state.currentFilterText.toLocaleLowerCase()
                ) ||
                (f.EntityMetaValue &&
                  f.EntityMetaValue.toLowerCase().includes(
                    this.state.currentFilterText.toLocaleLowerCase()
                  )) ||
                this.state.currentFilterText === ''
            ),
            editing: true,
            metaOptions: response,
            groups: groups,
          });
        });
      });
    });
    if (this.props.level === '') {
      let isoFieldOptions = await fetchIsoFields();
      let maintenanceMap = await fetchIsoData(this.props.items);
      this.setState({
        maintenanceData: maintenanceMap,
        ISOFields: isoFieldOptions,
      });
      let capitalAsset = { ...this.state.capitalAsset };
      // fetch capital fields data here as
      capitalAsset.capitalFields = await this.getCapitalAssetData(
        this.props.items[0].Entity_DBID
      );
      if (capitalAsset.capitalFields) {
        let capitalFields = capitalAsset.capitalFields;
        let readOnlyCapitalAsset = false;
        let readOnlyPOIO = false;
        let readOnlyCtag = false;
        let orderIncomplete = false;
        let ctag = getFieldValue(capitalFields, CAPITAL_ASSET_FIELDS.C_TAG);
        let poNumber = getFieldValue(
          capitalFields,
          CAPITAL_ASSET_FIELDS.PO_NUMBER
        );
        let ioNumber = getFieldValue(
          capitalFields,
          CAPITAL_ASSET_FIELDS.IO_NUMBER
        );
        if (poNumber !== null || ioNumber !== null) {
          readOnlyPOIO = true;
        }
        if (readOnlyPOIO && (!poNumber || !ioNumber)) {
          orderIncomplete = true;
        }
        if (ctag || orderIncomplete) {
          readOnlyCtag = true;
        }
        if (ctag && poNumber && ioNumber) {
          readOnlyCapitalAsset = true;
        }

        capitalAsset.isCapitalAsset = true;
        this.setState({ capitalAssetReadOnly: readOnlyCapitalAsset });
        this.setState({ readOnlyPOIO: readOnlyPOIO });
        this.setState({ readOnlyCtag: readOnlyCtag });
        this.setState({ capitalAsset: capitalAsset });
        this.setState({ existingCapitalAsset: capitalAsset });
      }
    }
  }

  async getCapitalAssetData(entityId) {
    try {
      const response = await Api({
        sp: 'getCapitalAssetDataForEntity',
        json: { entityID: entityId },
      });

      if (response && response.length > 0) {
        response.forEach((field) => {
          // Parse JSON strings into objects/arrays
          if (field.EntityMetaType === 'PO Number') {
            let object = {
              pi_dbid: '',
              po_num: field.EntityMetaValue,
            };
            field.EntityMetaValue = { ...object };
          } else if (field.EntityMetaType === 'IO Number') {
            let object = {
              io_dbid: '',
              io_num: field.EntityMetaValue,
            };
            field.EntityMetaValue = { ...object };
          }
        });
        return response;
      }
    } catch (error) {
      console.error('Error fetching capital asset data:', error);
      return null;
    }
  }

  makeTree(input, indexer, maker, root = 0) {
    const index = this.makeIndex(input, indexer);
    const many = (all = []) => all.map(one); // 1
    const one = (single = {}) => maker(single, (r) => many(index.get(r))); // 2
    return many(index.get(root));
  }

  makeIndex = (items, indexer) => {
    const insert = (r, k, v) => r.set(k, (r.get(k) ?? []).concat([v]));
    return items.reduce((r, i) => insert(r, indexer(i), i), new Map());
  };

  // todo: this is almost duplicated in groups.js
  updateMeta = (val, item) => {
    val =
      item.DataType === 'Date' || item.DataType === 'Binary' ? val : val.trim();

    if (item.DataType === '4-Digit Number') {
      val = val.toString().padStart(4, '0');
    } else if (item.DataType === '12-Digit Number') {
      val = val.toString().padStart(12, '0');
    }

    if (item.EntityMetaValue === val || (val === '' && !item.EntityMetaValue)) {
      return;
    }
    if (
      item.DataType === 'Date' &&
      datePickerToShortDate(item.EntityMetaValue) === datePickerToShortDate(val)
    ) {
      return; // new and old date values are the same for the meta type
    }

    if (validateField(item, val)) {
      // set val to empty for deletion if binary and 0/false
      val = item.DataType === 'Binary' ? (val === 0 ? '' : val) : val;
      if (item.DataType === 'Image' && val !== '') {
        item.EntityMeta_DBID = -1;
      }
      let entities = [];
      let entitiesToUpdate = [];
      let singleTemplateField = this.state.allTemplateFields.filter(
        (x) => x.EntityMeta_DBID === item.EntityMeta_DBID
      )[0];
      if (item.AllowMultiple) {
        // add new metaId for all the selected entitites
        if (item.EntityMeta_DBID === -1) {
          this.props.items.forEach((entity) => {
            entities.push({
              entityId: entity.Entity_DBID,
              metaId: -1,
            });
          });
        } else {
          // fetch all the pre-existing required metaids of all entities
          entitiesToUpdate = this.state.allTemplateFields.filter(
            (t) =>
              [singleTemplateField.initialValue, item.EntityMetaValue].includes(
                t.EntityMetaValue
              ) && t.EntityMetaType_DBID === item.EntityMetaType_DBID
          );
        }
      } else {
        entitiesToUpdate = this.state.allTemplateFields.filter(
          (x) => x.EntityMetaType === item.EntityMetaType
        );
      }

      entitiesToUpdate.forEach((x) => {
        entities.push({
          entityId: x.Entity_DBID,
          metaId: x.EntityMeta_DBID ?? -1,
        });
      });

      let json = {
        entities: entities,
        typeId: item.EntityMetaType_DBID,
        val: val,
        level: this.props.level,
      };
      if (item.IsUnique || item.UniqueBy) {
        // check for unique values by field
        Api({
          sp: 'checkUnique',
          json: {
            entityId: item.Entity_DBID,
            fieldId: item.EntityMetaType_DBID,
            val: val,
            typeId: item.EntityType_DBID,
            isUnique: item.IsUnique,
          },
        }).then((r) => {
          if (r.length) {
            const unique = r[0].UniqueName
              ? ' for ' + r[0].UniqueName + ': ' + r[0].UniqueVal
              : '';
            toast.error(
              r[0].EntityName +
                ' already has ' +
                r[0].EntityMetaType +
                ': ' +
                r[0].EntityMetaValue +
                unique
            );
            this.getData();
          } else {
            this.executeUpdate(json, item, val, entitiesToUpdate);
          }
        });
      } else {
        this.executeUpdate(json, item, val, entitiesToUpdate);
      }
    }
  };

  executeUpdate = (json, item, val) => {
    this.setState({ refresh: true });
    Api({
      sp: 'updateMetaByEntities',
      json: json,
    }).then(() => {
      if (item.DataType !== 'Image') {
        item.EntityMetaValue = val;
      }

      this.getData();
      // this.props.updateTable(entitiesToUpdate, val);
      // // if (item.DataType === "Image" && val === "") {
      // //   Delete(this.state.imgServer, item.EntityMetaValue).then(() => {});
      // // }
      if (item.DataType === 'Date' && val !== null && val !== '') {
        val = datePickerToShortDate(val);
      }

      toast.success(
        item.EntityMetaType +
          (item.AllowMultiple && !val.length
            ? ' removed'
            : item.DataType === 'Binary'
              ? ' updated to ' + (val ? 'True' : 'False')
              : ' updated to ' + (val.length ? val : '(Blank)'))
      );
    });
  };

  remove = (item) => {
    let template = this.state.template.filter(
      (x) => x.EntityMeta_DBID !== item.EntityMeta_DBID
    );
    let filterTermLower = this.state.currentFilterText.toLowerCase();
    let newItems = template.filter(
      (f) =>
        f.EntityMetaType.toLowerCase().includes(filterTermLower) ||
        (f.EntityMetaValue &&
          f.EntityMetaValue.toLowerCase().includes(filterTermLower)) ||
        this.state.currentFilterText === ''
    );
    this.setState({ template: template, filteredTemplate: newItems });
    this.updateMeta('', item);
  };

  addEntry = (item) => {
    let newItem = {};
    newItem = Object.assign(newItem, item);
    newItem.EntityMeta_DBID = -1;
    newItem.EntityMetaValue = '';
    newItem.children = [];
    delete newItem.values;
    let template = this.state.template;
    let filterTermLower = this.state.currentFilterText.toLowerCase();
    template.push(newItem);
    let newItems = template.filter(
      (f) =>
        f.EntityMetaType.toLowerCase().includes(filterTermLower) ||
        (f.EntityMetaValue &&
          f.EntityMetaValue.toLowerCase().includes(filterTermLower)) ||
        this.state.currentFilterText === ''
    );
    newItems.sort((a, b) => (a.Sort > b.Sort ? 1 : a.Sort < b.Sort ? -1 : 0));
    this.setState({ template: template, filteredTemplate: newItems });
    // if item is at the bottom of the field list and a row is added, scroll to the bottom
    if (
      item.Sort === Math.max(...this.state.filteredTemplate.map((o) => o.Sort))
    ) {
      setTimeout(() => {
        this.bottomRef.current.scrollIntoView({ behavior: 'smooth' });
      }, 0);
    }
  };

  filterTemplate = (filterTerm) => {
    let template = this.state.template;
    let filterTermLower = filterTerm.toLowerCase();
    let newItems = template.filter(
      (f) =>
        f.EntityMetaType.toLowerCase().includes(filterTermLower) ||
        (f.EntityMetaValue &&
          f.EntityMetaValue.toLowerCase().includes(filterTermLower)) ||
        filterTerm === ''
    );
    this.setState({
      filteredTemplate: newItems,
      currentFilterText: filterTerm,
    });
  };

  renameEntity = (val) => {
    val = val.trim();
    let prevName = this.state.currentEntityName;
    this.setState({ refresh: true });

    if (val.length) {
      Api({
        sp: 'renameEntity',
        json: { id: this.props.items[0].Entity_DBID, val: val },
      }).then((response) => {
        if (response[0].error) {
          toast.error(response[0].error);
        } else {
          toast.success(prevName + ' renamed to ' + val);
          this.setState({ renaming: false, currentEntityName: val });
        }
      });
    }
  };

  // if capital asset data is valid
  async isCapitalAssetValid() {
    if (this.state.capitalAssetReadOnly)
      return true; // skip validation if read-only
    else if (!this.state.capitalAsset.isCapitalAsset) return true;
    else if (!this.areCapitalFieldsComplete()) {
      // show second modal for incomplete capital fields
      this.setState({ capitalError: true });
      return false;
    } else if (
      !this.state.readOnlyCtag &&
      (!this.isCTagValid() || !(await this.checkDuplicateFields()))
    ) {
      return false;
    } else {
      return true;
    }
  }

  isCTagValid = () => {
    const ctag = getFieldValue(
      this.state.capitalAsset.capitalFields,
      CAPITAL_ASSET_FIELDS.C_TAG
    );

    if (ctag && !CTAG_PATTERN.test(ctag)) {
      toast.error(CTAG_FORMAT_MESSAGE);
      return false;
    }
    return true;
  };

  checkDuplicateFields = async () => {
    let fields = [];
    fields = [
      ...fields,
      ...this.state.capitalAsset.capitalFields.filter((f) => f.IsUnique === 1),
    ];
    if (fields.length > 0) {
      let result = await Api({
        sp: 'getDuplicateEntity',
        json: {
          fields: fields,
        },
      });
      if (result.length > 0) {
        let obj = result[0];
        toast.error(
          obj.EntityName +
            ' has the same ' +
            obj.MetaValue +
            ' for ' +
            obj.EntityMetaType
        );
        return false;
      } else {
        return true;
      }
    }
  };

  areCapitalFieldsComplete = () => {
    // Use the common utility function
    const selectedPONumber = getFieldValue(
      this.state.capitalAsset.capitalFields,
      CAPITAL_ASSET_FIELDS.PO_NUMBER
    );
    const selectedIONumber = getFieldValue(
      this.state.capitalAsset.capitalFields,
      CAPITAL_ASSET_FIELDS.IO_NUMBER
    );
    const ctag = getFieldValue(
      this.state.capitalAsset.capitalFields,
      CAPITAL_ASSET_FIELDS.C_TAG
    );

    return selectedPONumber && selectedIONumber && ctag && ctag.trim();
  };

  skipCapitalUpdate = () => {
    this.setState({ capitalError: false });
    this.props.close(this.state.refresh);
  };

  closeErrorPopup = () => {
    this.setState({ capitalError: false });
  };

  updateCapitalData = async () => {
    let apiPayload = {};
    const selectedPONumber =
      !this.state.readOnlyPOIO &&
      getFieldValue(
        this.state.capitalAsset.capitalFields,
        CAPITAL_ASSET_FIELDS.PO_NUMBER
      );
    const selectedIONumber =
      !this.state.readOnlyPOIO &&
      getFieldValue(
        this.state.capitalAsset.capitalFields,
        CAPITAL_ASSET_FIELDS.IO_NUMBER
      );
    const ctag =
      !this.state.readOnlyCtag &&
      getFieldValue(
        this.state.capitalAsset.capitalFields,
        CAPITAL_ASSET_FIELDS.C_TAG
      );
    apiPayload.entityId = this.props.items[0].Entity_DBID;
    apiPayload.poNumber = selectedPONumber?.po_num || null;
    apiPayload.ioNumber = selectedIONumber?.io_num || null;
    apiPayload.poItemId = selectedPONumber?.pi_dbid || null;
    apiPayload.ctag = ctag || null;

    let result = await Api({
      sp: 'updateCapitalAssetByEntity',
      json: apiPayload,
    });

    if (result) {
      toast.success('Capital Asset fields updated successfully.');
      this.props.close(true);
    } else {
      toast.error('Error updating Capital Asset fields. Try again later.');
      this.props.close(false);
    }
  };

  capitalAssetChanged = () => {
    const { capitalAsset, existingCapitalAsset } = this.state;
    if (capitalAsset.isCapitalAsset !== existingCapitalAsset.isCapitalAsset) {
      return true;
    }

    const getNormalizedValue = (fields, key) => {
      let val = getFieldValue(fields, key);
      if (!val) return null;
      // For PO_NUMBER and IO_NUMBER, getFieldValue returns objects; extract the
      // relevant string identifier for value-based comparison
      if (key === CAPITAL_ASSET_FIELDS.PO_NUMBER) return val.po_num || null;
      if (key === CAPITAL_ASSET_FIELDS.IO_NUMBER) return val.io_num || null;
      return val;
    };

    const keys = [
      CAPITAL_ASSET_FIELDS.C_TAG,
      CAPITAL_ASSET_FIELDS.PO_NUMBER,
      CAPITAL_ASSET_FIELDS.IO_NUMBER,
    ];

    for (let key of keys) {
      const newVal = getNormalizedValue(capitalAsset.capitalFields, key);
      const existingVal = getNormalizedValue(
        existingCapitalAsset.capitalFields,
        key
      );
      if (newVal !== existingVal) {
        return true;
      }
    }
    return false;
  };

  async onHideValidations() {
    if (
      this.props.level === '' &&
      !this.state.capitalAssetReadOnly &&
      this.capitalAssetChanged()
    ) {
      if (await this.isCapitalAssetValid()) {
        this.updateCapitalData();
      } else {
        return null;
      }
    } else {
      this.props.close(this.state.refresh);
    }
  }

  render = () => {
    const { capitalAsset } = this.state;
    return (
      <Modal
        size="lg"
        show={this.props.open}
        onHide={() => this.onHideValidations()}
        className={
          this.state.capitalError ? 'entity-modal fade-edit' : 'entity-modal'
        }
        keyboard={false}
      >
        <Modal.Header closeButton="true">
          {this.props.items?.length > 1 ? (
            <Modal.Title>Update Configurations</Modal.Title>
          ) : (
            <Modal.Title>
              <div className="renameLabel">
                {this.props.canEdit && this.props.level !== 'Material'
                  ? 'Update'
                  : null}
                &nbsp;
              </div>
              {this.state.renaming ? (
                <div className="renameInput">
                  <Form.Control
                    type="text"
                    className="inputBoxText"
                    autoFocus
                    placeholder="Entity Name"
                    defaultValue={this.state.currentEntityName}
                    onBlur={(e) => this.renameEntity(e.target.value)}
                  />
                </div>
              ) : this.props.canEdit &&
                !['Material'].includes(this.props.level) ? (
                <Hint
                  placement="top"
                  delay={{ show: 250, hide: 400 }}
                  title={
                    'Click to rename ' +
                    (this.props.level.length ? this.props.level : 'Equipment')
                  }
                >
                  <span
                    className="pointer child-link"
                    onClick={() => this.setState({ renaming: true })}
                  >
                    {this.state.currentEntityName}
                  </span>
                </Hint>
              ) : (
                <span>{this.state.currentEntityName}</span>
              )}{' '}
              Configuration
            </Modal.Title>
          )}
        </Modal.Header>
        <Modal.Body>
          <TabContext value={this.state.tabValue}>
            <TabList
              onChange={this.handleTabChange}
              aria-label="basic tabs example"
            >
              <Tab
                className={
                  'details-tab' +
                  (!(this.props.level === '') ? ' no-pointer' : '')
                }
                value="1"
                label="Details"
              />

              {this.props.level === '' ? (
                <Tab className="details-tab" value="2" label="Service" />
              ) : (
                ''
              )}
              {this.props.level === '' && this.props.items.length === 1 ? (
                <Tab className="details-tab" value="3" label="CapX ID" />
              ) : (
                ''
              )}
            </TabList>
            <br />
            <TabPanel value="1" className="muiTabPanelDetails">
              <>
                <Form.Control
                  type="text"
                  placeholder="Filter"
                  value={this.state.currentFilterText}
                  onChange={(e) => this.filterTemplate(e.target.value)}
                  autoFocus
                />
                <br />
                <div className="fieldList-container">
                  <FieldList
                    items={this.state.filteredTemplate}
                    addEntry={this.addEntry}
                    update={this.updateMeta}
                    remove={this.remove}
                    users={this.state.users}
                    disabled={!this.props.canEdit}
                    updateTable={this.props.updateTable}
                    level={this.props.level}
                  />
                  <div ref={this.bottomRef}></div>
                </div>
              </>
            </TabPanel>
            <TabPanel value="2" className="muiTabPanelDetails">
              {this.props.level === '' ? (
                <EquipmentMaintenanceFields
                  level={this.props.level}
                  canEdit={this.props.canEdit}
                  ISOFields={this.state.ISOFields}
                  isoData={this.state.maintenanceData}
                  showValue={this.props.items?.length === 1 ? true : false}
                  entities={this.props.items}
                  updateISOData={(value, isoField) =>
                    this.handleEquipmentMaintenanceFieldsChange(value, isoField)
                  }
                  editing={true}
                  close={(refresh) =>
                    this.props.close(refresh ?? this.state.refresh)
                  }
                  handlePerformService={(refresh) =>
                    this.props.handlePerformService(refresh)
                  }
                  openServiceHistory={(refresh) =>
                    this.props.openServiceHistory(refresh)
                  }
                />
              ) : (
                ''
              )}
            </TabPanel>
            <TabPanel value="3" className="muiTabPanelDetails">
              {this.props.level === '' ? (
                <CapitalAssetSelector
                  onCapitalAssetChange={(data) =>
                    this.handleCapitalAssetChange(data)
                  }
                  initialData={capitalAsset}
                  parent="entityEdit"
                  readOnlyPOIO={this.state.readOnlyPOIO}
                  readOnlyCtag={this.state.readOnlyCtag}
                  errorModal={this.state.capitalError}
                  skipCapitalUpdate={this.skipCapitalUpdate}
                  closeErrorPopup={this.closeErrorPopup}
                />
              ) : (
                ''
              )}
            </TabPanel>
          </TabContext>
        </Modal.Body>
      </Modal>
    );
  };
}
export default EntityEdit;
